var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1c90ff",
    d: "M32 160C32 124.7 60.7 96 96 96L320 96C343.7 96 364.4 108.9 375.4 128L415.8 128C448.2 128 477.4 147.6 489.8 177.5L533.6 283.8L535.3 288L560 288C586.5 288 608 309.5 608 336L608 400C608 426.5 586.5 448 560 448L559.6 448C559.8 450.6 560 453.3 560 456C560 504.6 520.6 544 472 544C423.4 544 384 504.6 384 456C384 453.3 384.1 450.6 384.4 448L239.7 448C239.9 450.6 240.1 453.3 240.1 456C240.1 504.6 200.7 544 152.1 544C103.5 544 64.1 504.6 64.1 456C64.1 452.4 64.3 448.9 64.7 445.5C45.7 439.1 32.1 421.1 32.1 400L32.1 352C14.4 352 .1 337.7 .1 320L.1 224C.1 206.3 14.4 192 32.1 192L32.1 160zM384 192L384 288L466.1 288L430.7 201.9C428.2 195.9 422.4 192 415.9 192L384 192zM192 456C192 433.9 174.1 416 152 416C129.9 416 112 433.9 112 456C112 478.1 129.9 496 152 496C174.1 496 192 478.1 192 456zM472 496C494.1 496 512 478.1 512 456C512 433.9 494.1 416 472 416C449.9 416 432 433.9 432 456C432 478.1 449.9 496 472 496z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrt);
export default __webpack_public_path__ + "static/media/QRT.c8385a10e6524df6cfd0912e21294e41.svg";
export { ForwardRef as ReactComponent };